module.exports = __webpack_public_path__ + "static/img/1389_phase_function_Paper_Points.1f29c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1389_phase_function_Paper_Points.png
// module id = 1RSP
// module chunks = 0